






















































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import lostFoundDetail from '../../../store/entities/lost-found-issues/lost-found-detail'
import SerialInfo from "@/store/entities/serialinfo"
import ViewSerial from "@/views/components/view-serials.vue"
import NoteModal from '../../components/note-modal.vue'
import AppConsts from '../../../lib/appconst';
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';

Vue.use(require("vue-moment"));
  @Component({
    components: { 'view-serials':ViewSerial, 'note-modal':NoteModal }
})
export default class ViewlostFound extends  mixins(DateTimeMixin, AbpBase){
    @Prop({type:Boolean,default:false}) value:boolean;
    lostFound:lostFoundDetail=new lostFoundDetail();
    id : number = 0;
    viewSerialModelShow: boolean = false;
    itemSerialForView : SerialInfo= new SerialInfo();
    viewNoteModelShow : boolean = false;
    confirmLostIssueNote :string="";
    async created(){
        this.id = + this.$root.$router.currentRoute.params.id;
        await this.getLostFoundIssue(this.id);
    }

    async getLostFoundIssue(id:number){
        await this.$store
            .dispatch({
                type: "lostFound/get",
                data: { id: id }
            })
            .then(result => {
                this.lostFound = result;
                this.id = this.lostFound.id;
                if(this.lostFound.pickListCode != ''){
                    this.lostFound.pickListUrl =  `/#/operations/picklist/${this.lostFound.pickListCode}`
                }
            });
    }

    showSerials () {
            this.itemSerialForView.sku = this.lostFound.sku;
            this.itemSerialForView.productName = this.lostFound.productName;
            this.itemSerialForView.qty = this.lostFound.qty;
            this.itemSerialForView.serialNoes = this.lostFound.serialNos;
            this.viewSerialModelShow = true;
    }

    goBack(){
        this.$emit("input", false);
        this.$root.$router.push({ name: "lostfound" });
    }

    canShowActionConfirm()
    {
        if(this.lostFound.isResolveLost && this.hasPermission(AppConsts.permissionNames.resolveLostIssue))
        {
            return true;
        }
       return false;
    }

    openModalConfirmLostIssue(){
        this.confirmLostIssueNote ="";
        this.viewNoteModelShow = true;
    }

    onConfirmLostIssue(){
        if(Util.isEmpty(this.confirmLostIssueNote))
        {
            Util.showErrorMsg(this,"Error.ConfirmNotLostIssueNoteIsRequired");
            return; 
        }

        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.ThisLostIssueCheckedPhysicalItem'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                await this.$store.dispatch({
                type:'lostFound/resolveLostIssue',
                data:{
                    id: this.id,
                    note: this.confirmLostIssueNote
                }
                }).then(async esult => {
                    await this.getLostFoundIssue(this.id);
                    Util.showSuccessMsg(this,"Success.ThisLostIssueConfirmSuccess");
                    this.confirmLostIssueNote="";
                });
            }
        })
    }

}
